import { ProfileDkTwoComponent } from '@ui/legacy-lib';
import { GlobalCustomQuestionsComponent } from '@ui/legacy-lib';
import {
  MemberSearchProfileComponent,
  MemberBasicInformationComponent
} from 'landlord/components/contacts-components';

export enum EditMemberWizardSteps {
  MEMBER_INFORMATION = 'memberInformation',
  SEARCH_PROFILES = 'searchProfiles',
  GLOBAL_CUSTOM_QUESTIONS = 'globalCustomQuestions',
  DK_TWO = 'dkTwo'
}

export const EditMemberStepsRoutes = [
  {
    path: EditMemberWizardSteps.MEMBER_INFORMATION,
    component: MemberBasicInformationComponent,
    data: {
      title: 'internal_list.wizard_step_1_title'
    }
  },
  {
    path: EditMemberWizardSteps.SEARCH_PROFILES,
    component: MemberSearchProfileComponent,
    data: {
      title: 'internal_list.wizard_step_2_title'
    }
  },
  {
    path: EditMemberWizardSteps.GLOBAL_CUSTOM_QUESTIONS,
    component: GlobalCustomQuestionsComponent,
    data: {
      title: 'register.global_questions_title'
    }
  },
  {
    path: EditMemberWizardSteps.DK_TWO,
    component: ProfileDkTwoComponent,
    data: {
      title: 'profile.dk_2_title_l'
    }
  }
];
